import { CheckIcon } from '@chakra-ui/icons';
import { Box, Button, IconButton, IconButtonProps } from '@chakra-ui/react';
import { FC } from 'react';

interface IAddonIconButton extends IconButtonProps {
  side?: 'left' | 'right';
}

const AddonIconButton: FC<IAddonIconButton> = ({ variant = 'primary', size = 'lg', side = 'right', icon = <CheckIcon />, ...rest }) => {
  return (
    <IconButton
      {...rest}
      icon={icon}
      size={size}
      w={'full'}
      h={'full'}
      variant={variant}
      sx={{
        height: '100%',
        [side === 'right' ? 'borderTopRightRadius' : 'borderTopLeftRadius']: 'var(--chakra-radii-lg)',
        [side === 'right' ? 'borderBottomRightRadius' : 'borderBottomLeftRadius']: 'var(--chakra-radii-lg)',
        [side === 'right' ? 'borderTopLeftRadius' : 'borderTopRightRadius']: 0,
        [side === 'right' ? 'borderBottomLeftRadius' : 'borderBottomRightRadius']: 0,
      }}
    />
  );
};

export const AddonIconTextButton: FC<IAddonIconButton> = ({
  variant = 'primary',
  size = 'lg',
  side = 'right',
  icon = <CheckIcon />,
  children,
  ...rest
}) => {
  return (
    <Button
      {...rest}
      size={size}
      w={'full'}
      h={'full'}
      variant={variant}
      fontSize={'sm'}
      sx={{
        height: '100%',
        [side === 'right' ? 'borderTopRightRadius' : 'borderTopLeftRadius']: 'var(--chakra-radii-lg)',
        [side === 'right' ? 'borderBottomRightRadius' : 'borderBottomLeftRadius']: 'var(--chakra-radii-lg)',
        [side === 'right' ? 'borderTopLeftRadius' : 'borderTopRightRadius']: 0,
        [side === 'right' ? 'borderBottomLeftRadius' : 'borderBottomRightRadius']: 0,
      }}
    >
      {children}
      <Box as={'span'} display={'inline-block'} ml={2}>
        {icon}
      </Box>
    </Button>
  );
};

export default AddonIconButton;
